export default class EnvironmentsSelectionComponent {
    constructor() {
        this.template = `<div ng-non-bindable id="ng-env-selection"></div>`;
        this.controller = EnvSelectionController;
        this.bindings = {
            vModel: '='
        };
    }
}

class EnvSelectionController {
    constructor($timeout) {
        this.$timeout = $timeout;
    }
    $onInit() {
        const vModel = this.vModel || [];
        const template = `<EnvironmentsSelection :value="model" @input="onInput"></EnvironmentsSelection>`;

        const onInputNgCb = (selectedEnvs) => this.onInputNg(selectedEnvs);

        this.vm = new Vue({
            el: '#ng-env-selection',
            template ,
            store: window.store,
            router: $vueRouter,
            props: {
                _model: Array
            },
            computed: {
                model() {
                    return this._model || vModel;
                }
            },
            methods: {
                onInput: (selectedEnvs) => onInputNgCb(selectedEnvs)
            }
        });
    }
    onInputNg(selectedEnvs) {
        this.vm._model = selectedEnvs;
        this.$timeout(() => {
            this.vModel = this.vm._model;
        });
    }
}



// WEBPACK FOOTER //
// ./ui_components/environments_selection/environments.selection.component.js